import { useMemo } from 'react';

import { CasEditForm, IEditForm } from 'src/compass/shared/components';

import CustomerFormFields from './CustomerFormFields';
import { CustomerSchema } from '../schema/CustomerSchema';

export default function CustomerForm({ row, onSaved }: IEditForm) {
  const { id } = row || {};

  const defaultValues = useMemo(() => (id ? row : {}), [id, row]);

  const onBeforeSave = (entityData: any) => {
    const { crmCompositeObj, ...rest } = entityData;
    return { ...rest, crmCompositeId: crmCompositeObj?.id };
  };

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onBeforeSave={onBeforeSave}
      onSaved={onSaved}
      entity="Utilities/Entity"
      schema={CustomerSchema}
    >
      <CustomerFormFields />
    </CasEditForm>
  );
}
